import { Box } from "@chakra-ui/react";
import ServiceArrivalRatesTable from "../ServiceArrivalRatesTable";
import ReportDataTable from "../../reports/ReportDataTable";
import ArrivalRatesPerServiceSummary from "../../branches/reports/ArrivalRatesPerServiceSummary";
import { ARRIVAL_RATES_PER_SERVICE_COLUMN_DEFINITIONS } from "../../../store/renderConfig";
import { getArrivalRatesPerServiceRowsForScope } from "../../../store/arrivalRatesPerServiceExport";
import { renderArrivalRatesPerServiceCell } from "../../branches/tables/BranchServicesTable";
import { buildArrivalRatesPerServiceInsights } from "../../../store/arrivalRatesPerServiceInsights";


const ArrivalRatesByService = ({ data, renderConfig, onRenderConfigChange }) => {
  const servicesData = Array.isArray(data) ? data : [];
  const organization = {
    branchName: "Entire Organization",
    organizationTotalArrivals: servicesData.reduce((sum, service) => sum + Number(service.total || 0), 0),
    servicesData,
  };
  const insights = buildArrivalRatesPerServiceInsights(organization);

  if (!renderConfig?.charts?.enabled) {
    return (
      <Box className="arrivalRatesPerServiceUnifiedBlock" mt="16px" mb="24px">
        <ArrivalRatesPerServiceSummary branch={organization} />
        <ReportDataTable
          columns={ARRIVAL_RATES_PER_SERVICE_COLUMN_DEFINITIONS}
          rows={getArrivalRatesPerServiceRowsForScope(
            {
              data: insights.rankedServices,
              scope: "Organization",
            },
            renderConfig
          )}
          renderConfig={renderConfig}
          renderCell={renderArrivalRatesPerServiceCell}
          presortedRows={true}
          onSortChange={(sort) => onRenderConfigChange?.({ ...renderConfig, sort })}
        />
      </Box>
    );
  }

  return (
    <>
      <ArrivalRatesPerServiceSummary branch={organization} />
      <h3>Top Service Trend Detail</h3>
      {insights.topChartServices.map((serviceData, index) => {
        return (
          <ServiceArrivalRatesTable
            key={index}
            index={index}
            serviceData={serviceData}
            renderConfig={renderConfig}
            onRenderConfigChange={onRenderConfigChange}
          />
        );
      })}
    </>
  );
};

export default ArrivalRatesByService;
